module.exports = __webpack_public_path__ + "media/images/icons/people-cc1aa8314a46643a3364a9a750466580.svg";